export default __webpack_public_path__ + "static/events-dark-2e52b126d505e4cc78f1ad887a378193.png";